import { useAuth0 } from '@auth0/auth0-react';
import { useMemo } from 'react';
import config from '../config';

export const useApiAuth = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

  const getAuthHeaders = useMemo(() => {
    return async () => {
      if (!isAuthenticated) {
        return {};
      }

      try {
        const accessToken = await getAccessTokenSilently({
          authorizationParams: {
            audience: config.auth0.audience,
            scope: 'openid profile email offline_access'
          }
        });
        return {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        };
      } catch (error) {
        console.error('Error getting access token:', error);
        return {
          'Content-Type': 'application/json'
        };
      }
    };
  }, [getAccessTokenSilently, isAuthenticated]);

  return {
    getAuthHeaders,
    isAuthenticated,
    isLoading
  };
};
